export enum Channel {
  DEFAULT = 'default',
  STOREFRONT = 'storefront',
}

export type ComponentId =
  | 'header'
  | 'sidebar'
  | 'profile_dropdown'
  | 'rewards_v3'
  | 'dashboard'
  | 'hamburger'
  | 'sidebar_custom_tabs'
  | 'loyalty_badges'
  | 'campaign_banner'
  | 'sidebar_profile_image'
  | 'sidebar_joined_date'
  | 'sidebar_full_name'
  | 'sidebar_point_system'
  | 'sidebar_referred_by';

export type MenuItemId =
  | 'dashboard'
  | 'stats'
  | 'rewards'
  | 'transactions'
  | 'activity'
  | 'assets'
  | 'sharing'
  | 'profile'
  | 'referral_network'
  | 'payment_settings';

type Tri = 'show' | 'hide' | 'inherit';

export type Capabilities = {
  allowedComponents: Set<ComponentId>;
  allowedRoutes: RegExp[];
  allowedMenuItems?: Set<MenuItemId>;
  allowCustomSidebarTabs?: boolean;
  profileMenu?: {
    profile?: Tri;
    // logout?: Tri;
    customTabs?: Tri;
  };
  gates?: Set<string>;
  featureFlags?: Set<string>;
};
